import { Container, Typography } from "@mui/material";
import { Grid, Box, Button } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useStyles } from "./piechartcard-styles";
import { useTheme } from "@mui/material/styles";

import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
  },
];

const BarChartComponent = () => {
  const theme = useTheme();

  return (
    <ResponsiveContainer width="99%">
      <BarChart width={730} height={200} data={data}>
        <CartesianGrid vertical={false} strokeWidth={.5}/>
        <XAxis tickLine={false} dataKey="name" />
        <YAxis axisLine={false} tickLine={false} />
        <Tooltip strokeDasharray="3 3" />
        {/* <Legend /> */}
        <Bar
            radius={[10, 10, 0, 0]}
          dataKey="pv"
          fill={theme.palette.primary.main}
          onMouseOver={() => {}}
          stroke={theme.palette.primary.main}
          background={true}
          barSize={13}
          strokeWidth={".1"}
        />
        {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
      </BarChart>
    </ResponsiveContainer>
  );
};

export const BarChartCard = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper} variant="elevation" elevation={0}>
      <Box  className={classes.cardContentsWrapper}>
        <Box className={classes.cardTextArea}>
          <Typography variant="h6" className={classes.cardHeader}>
           User Activations
          </Typography>

          <Typography className={classes.cardText}>
            
          Yearly User 24.65k
          </Typography>
        </Box>

        <Box sx={{ height: "20rem" }}>
          <BarChartComponent />
        </Box>
      </Box>
    </Paper>
  );
};
